import React from 'react';
export function PinFillIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.71 9.91l-1.53-1.52-4.57-4.57-1.52-1.53a1.003 1.003 0 10-1.42 1.42l.82.81-3.4 3.4a5 5 0 00-5.58 1l-.22.22a1 1 0 000 1.41l3.87 3.87-4.87 4.87a.999.999 0 000 1.42 1 1 0 001.42 0l4.86-4.87 3.87 3.87a1 1 0 001.41 0l.22-.22a5 5 0 001-5.58l3.4-3.4.81.82a1.002 1.002 0 001.42 0 1 1 0 00.01-1.42z"
  }));
}